/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode, useEffect } from "react";

import { useAuth0 } from "./Auth0";

type Props = {
  children: ReactNode;
};

export function AuthWall({ children }: Props) {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      void loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [loginWithRedirect, isAuthenticated]);

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return <div />;
}
